// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_SubscriptionSyncRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_SubscriptionSyncRow — one remote charge's reconciliation
 * outcome, as reported by SubscriptionReconciliationService::reconcile()
 * (lane='cycle') AND ::reconcileCreditPurchasesForFranchise()
 * (lane='credit_purchase') — see that class's docblock for why those are two
 * separate entry points (fase 1b, docs/platform-revenue-refactor-plan.md).
 * Both sweeps report through this SAME row shape because "one remote charge's
 * outcome" is the same fact regardless of which sweep pulled it.
 *
 * action vocabulary (SubscriptionReconciliationService::classify() /
 * materializePending()):
 *   applied         — routed through WebhookEventRouter and the underlying
 *                      handler actually moved local state.
 *   already_applied — the SAME idempotency guard a real webhook would have
 *                      hit (already_confirmed, grace_already_active,
 *                      already_cancelled, or a duplicate (provider,event_id)
 *                      delivery).
 *   materialized     — the ONE case the service writes itself: a cycle charge
 *                      with no local row yet, remote status still PENDING /
 *                      AWAITING_RISK_ANALYSIS. Written locally as 'pending'.
 *                      Never produced for lane='credit_purchase' — that lane
 *                      NEVER materializes (a lone remote charge cannot tell
 *                      you which pack it was).
 *   ignored          — nothing to do: unknown/no-op remote status, a missing
 *                      charge_id, or the credit-purchase lane's
 *                      never-materialize rule.
 *   failed           — a per-charge try/catch caught an exception (or a
 *                      named refusal — e.g. the credit-purchase lane's
 *                      revenue-book row missing/ambiguous, or a provider that
 *                      cannot be reached) for THIS charge only; `detail`
 *                      carries the reason. One bad charge never aborts the
 *                      rest of the sweep (see the service's FAILURE
 *                      ISOLATION).
 *
 * `detail` is a free-form machine string explaining `action` — null when
 * there is nothing more to say (e.g. a clean 'applied').
 *
 * `lane` is the discriminator between the two sweeps — declared here as a
 * REAL contract field (fase 1b). A prior round smuggled this as a
 * `credit_purchase:` prefix inside `detail` because the contract was out of
 * scope at the time; that prefix is gone everywhere. Vocabulary:
 *   cycle           — this charge belongs to a subscription's own billing
 *                      cycle (reconcile()).
 *   credit_purchase — this charge is an AI-credit top-up
 *                      (reconcileCreditPurchasesForFranchise()).
 */
import { registerContract } from './validate'

export interface Subscriptions_SubscriptionSyncRow {
charge_id?: string
remote_status?: string
action?: string
detail?: string
lane?: string
}

registerContract('Subscriptions_SubscriptionSyncRow', {
  charge_id:     { type: 'string',  required: false },
  remote_status: { type: 'string',  required: false },
  action:        { type: 'string',  required: false },
  detail:        { type: 'string',  required: false },
  lane:          { type: 'string',  required: false },
})
